/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const RoleManagementService = {
    /**
     * 删除角色
     * @param {*} roleId 角色Id
     * @returns Promise 
     */
    'removeRole': function (roleId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '35c41e85b5df68311e96aaa98a0dd76099b629ac', roleId)
            : execute(concreteModuleName, `/Role/removeRole`, 'json', 'POST', { roleId });
    }, 
    /**
     * 查询角色的信息列表
     * @param {*} pageNum 第几页 - 从1开始
     * @param {*} pageSize 每页多少条数据
     * @returns Promise 
     */
    'roleInfoList': function (pageNum, pageSize) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '8bf830f4c999ce03f332ed78a553676854ed5885', {pageNum, pageSize})
            : execute(concreteModuleName, `/Role/roleInfoList`, 'json', 'POST', { pageNum, pageSize });
    }, 
    /**
     * 获取当前用户下的角色信息列表
     * @returns Promise 
     */
    'roleInfoListByCurrentUser': function () {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'c6d8420f8f97f7b72fc0750e9e204eb11dee9210')
            : execute(concreteModuleName, `/Role/roleInfoListByCurrentUser`, 'json', 'GET');
    }, 
    /**
     * 导出角色列表
     * @returns Promise 
     */
    'exportRoleInfoList': function () {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'e7e0d56b5c45f0527c79a0627cef38c412e7b690')
            : execute(concreteModuleName, `/Role/exportRoleInfoList`, 'json', 'GET');
    }, 
    /**
     * 修改角色信息
     * @param {*} updateRoleInfoPo 
     * @returns Promise 
     */
    'changeRoleInfoByRoleId': function (updateRoleInfoPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'c2128903cdd1024f10f44831c39de517de752ca6', updateRoleInfoPo)
            : execute(concreteModuleName, `/Role/changeRoleInfoByRoleId`, 'json', 'POST', updateRoleInfoPo);
    }, 
    /**
     * 添加角色
     * @param {*} addRoleInfoPo 
     * @returns Promise 
     */
    'addRole': function (addRoleInfoPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '07fb2c8f26a686751381fe2ef1c278b18eaead21', addRoleInfoPo)
            : execute(concreteModuleName, `/Role/addRole`, 'json', 'POST', addRoleInfoPo);
    }, 
    /**
     * 根据角色ID查询角色的信息
     * @param {*} roleId 角色Id
     * @returns Promise 
     */
    'roleInfoByRoleId': function (roleId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'a3bcd6215cae506cce3b9ea043518f0e5527f533', roleId)
            : execute(concreteModuleName, `/Role/roleInfoByRoleId`, 'json', 'POST', { roleId });
    }
}

export default RoleManagementService
